import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  allTopics: {
    id: 'discussions.navigation.breadcrumbMenu.allTopics',
    defaultMessage: 'Topics',
    description: 'Topics from Breadcrumb Menu item',
  },
  showAll: {
    id: 'discussions.navigation.breadcrumbMenu.showAll',
    defaultMessage: 'Show all',
    description: 'Option to show all items in a section of the breadcrumb',
  },
});

export default messages;
